export const DAO_CODE = 'USER' + '_DAO';
